module.exports = __webpack_public_path__ + "static/media/equipment.2213dbb6.svg";